import { Options, Prop, Vue } from 'vue-property-decorator';
import BankCard from './bank-card/index.vue';
import BankCardV2 from './bank-card-v2/index.vue';
import AddBankModal from './add-bank-modal/index.vue';
import { EventEmitter } from 'events';
import store from '@/trust-atcs-app/store';
import { QuestionType } from '../question-type';

@Options({
  components: {
    BankCard,
    BankCardV2,
    AddBankModal,
  },
})
export default class BankAccount extends Vue {
  @Prop()
  private questionTypeId!: number;

  @Prop()
  private banks!: any[];

  @Prop()
  private qWording!: string;

  @Prop()
  private formType!: string;

  private showNewBankModal = false;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  mounted(): void {
    this.$emit('validForm', this.validForm());
  }

  private validForm(): boolean {
    return this.banks?.length > 0 && this.validFormBank();
  }

  private addNewBankAccount() {
    this.eventCtrl.emit('save-section', false, true, true);
    this.showNewBankModal = true;
  }

  private removeBankAccount(index: number) {
    this.banks.splice(index, 1);
    this.$emit('validForm', this.validForm());
    this.eventCtrl.emit('save-section', false, true, false);
  }

  private validFormBank(): boolean {
    let allValid = true;
    if (this.banks) {
      for (let i = 0; i < this.banks.length; i++) {
        allValid = this.validFormEachBank(this.banks[i]);
        // console.log('all banks Valid: ', i, allValid);
        if (!allValid) {
          break;
        }
      }
    }

    this.$emit('validForm', allValid);
    return allValid;
  }

  private validFormEachBank(bank: any): boolean {
    let eachBankValid = true;
    for (let i = 0; i < bank.atcsSubQuestions.length; i++) {
      const answerCurrency = bank.atcsSubQuestions[i].responses[0]?.answerCurrency;
      if (bank.atcsSubQuestions[i].atcsQuestionTypeId == QuestionType.Currency && answerCurrency == null) {
        eachBankValid = false;
        break;
      }
      const answerTxt = bank.atcsSubQuestions[i].responses[0]?.answerTxt;
      if (
        bank.atcsSubQuestions[i].atcsQuestionTypeId == QuestionType.TextArea &&
        (answerTxt == null || answerTxt == '')
      ) {
        eachBankValid = false;
        break;
      }
      if (bank.atcsSubQuestions[i].atcsQuestionTypeId == QuestionType.Text && (answerTxt == null || answerTxt == '')) {
        eachBankValid = false;
        break;
      }

      const ignoreReasonForVariance = bank.atcsSubQuestions[i].responses[0]?.ignoreReasonForVariance;
      if (!ignoreReasonForVariance && bank.atcsSubQuestions[i].atcsQuestionTypeId == QuestionType.TextAreaConditional && (answerTxt == null || answerTxt == '')) {
        eachBankValid = false;
        break;
      }
      const answerNumber = bank.atcsSubQuestions[i].responses[0]?.answerNumber;
      if (
        bank.atcsSubQuestions[i].atcsQuestionTypeId == QuestionType.Number &&
        (answerNumber == null || answerNumber < 0)
      ) {
        eachBankValid = false;
        break;
      }

      if (bank.atcsSubQuestions[i].atcsQuestionTypeId == QuestionType.RadioButtonHorizontal) {
        // Get all radio responses if not null
        const responses = bank.atcsSubQuestions[i].responses.filter((x: any) => x.answerIsSelected != null);
        if (responses.length == 0) {
          eachBankValid = false;
          break;
        }
      }
    }
    return eachBankValid;
  }

  get QuestionType(): any {
    return QuestionType;
  }
}
